import { h, Fragment } from "preact";
import Article from "./article";
import useBlogCardHeights from "../helpers/useBlogCardHeights";

export default function PostFeed({ data }) {
  const { articles } = data;
  const [trackHeight, cardContentHeight] = useBlogCardHeights();

  return (
    <div className="blog-post-feed__articles">
      {articles.map((id) => (
        <Article
          trackHeight={(height) => trackHeight({ id, height })}
          minHeight={cardContentHeight}
          id={id}
          key={id}
        />
      ))}
    </div>
  );
}
